/* eslint-disable promise/param-names */
import { SENSOR_REQUEST, SENSOR_SUCCESS, SENSOR_ERROR , SENSOR_SELECT} from '../actions/sensors'
import Vue from 'vue'


const state = {
  status: 'unkown',
  loaded : false,
  sensorList : [],
  selected : '',
}



const getters = {
  getSensorStatus: state => state.status,
  getSensorList: state => state.sensorList,
  getSensorSelected : state => state.selected
}

const actions = {
  [SENSOR_REQUEST]: ({commit, dispatch}) => {
    commit(SENSOR_REQUEST)

    Vue.axios.get('/api/v1/sensor').then(resp => {
      //console.log(resp.data)
      commit(SENSOR_SUCCESS, resp.data)

      if (resp.data.length > 0) {
        // Select the first sensor:
        commit(SENSOR_SELECT, resp.data[0].id)
      }
    }).catch(resp => {
      commit(SENSOR_ERROR)
    })


  }, 
}

const mutations = {
  [SENSOR_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [SENSOR_SUCCESS]: (state, resp) => {
    state.status = 'success'
    Vue.set(state, 'sensorList', resp)
  },
  [SENSOR_SELECT]: (state, sensorID) => {
    state.sensorList.forEach(element => {
      if (sensorID == element.id) {
        Vue.set(state, 'selected', element)}     
    });
    
  },
  [SENSOR_ERROR]: (state) => {
    state.status = 'error'
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
